(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Typing effect for .styl-type-text p
    document.querySelectorAll('.styl-type-text p').forEach(el => {
        let i = 0;
        let txt = el.textContent.trim();
        let speed = 2;
        let started = false;
        el.textContent = "";

        function typeWriter() {
            if (i < txt.length) {
                el.textContent += txt.charAt(i);
                i++;
                setTimeout(typeWriter, speed);
            }
        }

        const typeObserver = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !started) {
                    started = true;
                    el.classList.add("in-view");
                    typeWriter();
                    obs.unobserve(el);
                }
            });
        }, { threshold: 0.5 });

        typeObserver.observe(el);
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Typing effect for .styl-type-text p
    document.querySelectorAll('.styl-type-text p').forEach(el => {
        let i = 0;
        let txt = el.textContent.trim();
        let speed = 2;
        let started = false;
        el.textContent = "";

        function typeWriter() {
            if (i < txt.length) {
                el.textContent += txt.charAt(i);
                i++;
                setTimeout(typeWriter, speed);
            }
        }

        const typeObserver = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !started) {
                    started = true;
                    el.classList.add("in-view");
                    typeWriter();
                    obs.unobserve(el);
                }
            });
        }, { threshold: 0.5 });

        typeObserver.observe(el);
    });

    // Fallback animation for other elements
    const fallbackObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('in-view');
            }
        });
    }, { threshold: 0.7 });

    document.querySelectorAll('.animate-on-scroll, .slide-in-left, .slide-in-right, .scale-up, .text-reveal').forEach((el) => {
        fallbackObserver.observe(el);
    });
});


  } catch(e) { console.error(e); }
})();
})();
